export const inventoryColumns = [
  {
    header: "Barcode",
    accessorKey:"barcode",
    width:"140px"
  },
  {
    header: "Description",
    accessorKey: "description",
    width: "400px",
  },
  {
    header: "Warehouse Qty",
    accessorKey: "quantity",
    width: "140px",
  },
  {
    header: "Hold Qty",
    accessorKey: "holdQty",
    width: "100px",
  },
  {
    header: "Committed Qty",
    accessorKey: "committedQty",
    width: "140px",
  },
  {
    header: "Allocated Qty",
    accessorKey: "allocatedQty",
    width: "140px",
  },
  {
    header: "Available Qty",
    accessorKey: "availableQty",
    width: "140px",
  },
  {
    header: "Zone Id",
    accessorKey: "zoneId",
  },
];
export const stockMovementColumns = [
  {
    header: "Opn Code",
    accessorKey: "opnCode",
  },
  {
    header: "Tran Doc Code",
    accessorKey: "tranDocCode",
  },
  {
    header: "Tran Doc Date",
    accessorKey: "tranDocDate",
  },
  {
    header: "Tran Line No",
    accessorKey: "tranLineNo",
  },
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone Id",
    accessorKey: "zoneID",
  },
  {
    header: "Location Id",
    accessorKey: "locationID",
  },
  {
    header: "Carton Id",
    accessorKey: "cartonID",
  },
  {
    header: "In",
    accessorKey: "in",
  },
  {
    header: "Out",
    accessorKey: "out",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Pallet Nbr",
    accessorKey: "palletNbr",
  },
  {
    header: "Customs Lot",
    accessorKey: "customsLot",
  },
  {
    header: "Manual Lot",
    accessorKey: "manualLot",
  },
];
export const locationDetailsColumns = [
  {
    header: "Warehouse Code",
    accessorKey: "warehouseCode",
  },
  {
    header: "Zone Id",
    accessorKey: "zoneID",
  },
  {
    header: "Location Id",
    accessorKey: "locationID",
  },
  {
    header: "Carton Id",
    accessorKey: "cartonID",
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
  },
  {
    header: "Hold Qty",
    accessorKey: "holdQty",
  },
  {
    header: "Allocated Qty",
    accessorKey: "allocatedQty",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Pallet Nbr",
    accessorKey: "palletNbr",
  },

  {
    header: "Pallet Type",
    accessorKey: "palletType",
  },
  {
    header: "Customs Lot",
    accessorKey: "customsLot",
  },
  {
    header: "Manual Lot",
    accessorKey: "manualLot",
  },
  {
    header: "Remark",
    accessorKey: "remark",
  },
];
export const skuDetailscolumns = [
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Carton Id",
    accessorKey: "cartonID",
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
  },
  {
    header: "Hold Qty",
    accessorKey: "holdQty",
  },
  {
    header: "Allocated Quantity",
    accessorKey: "allocatedQty",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Pallet Nbr",
    accessorKey: "palletNbr",
  },

  {
    header: "Pallet Type",
    accessorKey: "palletType",
  },
  {
    header: "Customs Lot",
    accessorKey: "customsLot",
  },
  {
    header: "Manual Lot",
    accessorKey: "manualLot",
  },
  {
    header: "Remark",
    accessorKey: "remark",
  },
];

export const locationStockMovementcolumns = [
  {
    header: "Opn Code",
    accessorKey: "opnCode",
  },
  {
    header: "Tran Doc Code",
    accessorKey: "tranDocCode",
  },
  {
    header: "Tran Doc Date",
    accessorKey: "tranDocDate",
  },
  {
    header: "Tran Line No",
    accessorKey: "tranLineNo",
  },
  {
    header: "SKU Code",
    accessorKey: "skuCode",
  },
  {
    header: "Carton Id",
    accessorKey: "cartonID",
  },
  {
    header: "In",
    accessorKey: "in",
  },
  {
    header: "Out",
    accessorKey: "out",
  },
  {
    header: "Expiry Date",
    accessorKey: "expiryDate",
  },
  {
    header: "OLN",
    accessorKey: "oln",
  },
  {
    header: "MLN",
    accessorKey: "mln",
  },
  {
    header: "Pallet Nbr",
    accessorKey: "palletNbr",
  },
  {
    header: "Customs Lot",
    accessorKey: "customsLot",
  },
  {
    header: "Manual Lot",
    accessorKey: "manualLot",
  },
];
